export const US_OPEN_CENTURION_EXCLUSIVE_ID = 5000;
export const US_OPEN_PLATINUM_EXCLUSIVE_ID = 5040;
